import React from 'react'
import TimeSheet from '../Components/Attendance/TimeSheet/TimeSheet'

const TimesheetPage = () => {
  return (
    <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
      <TimeSheet/>
    </div>
  )
}

export default TimesheetPage
